import { createReduxEnhancer } from '@sentry/react';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { thunk } from 'redux-thunk';
import reducers from '../reducers';

// Build middleware
const middleware = applyMiddleware(thunk);

const sentryReduxEnhancer = createReduxEnhancer({});

const enhancer =
  import.meta.env.VITE_APP_DEBUG === 'true' ||
  sessionStorage.getItem('TestMode') === 'true'
    ? composeWithDevTools(middleware, sentryReduxEnhancer)
    : compose(middleware, sentryReduxEnhancer);

const appReducer = combineReducers(reducers);

const rootReducer = (state, action) => {
  if (action.type === 'RESET') {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

// Make our store with our reducers and middleware
const store = createStore(rootReducer, enhancer);

export default store;
